import { fetchCouponGoodsCount } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import {
  type GetCouponGoodsCountServiceRequest,
  GetCouponGoodsCountServiceRequestSchema,
  type GetCouponGoodsCountServiceResponse,
  GetCouponGoodsCountServiceResponseSchema,
} from './getCouponGoodsCount.dto';

export const getCouponGoodsCountService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetCouponGoodsCountServiceRequestSchema),
    async (
      request: GetCouponGoodsCountServiceRequest,
    ): Promise<GetCouponGoodsCountServiceResponse> => {
      const response = await fetchCouponGoodsCount(request);
      return response.data;
    },
    validateServiceResponse(GetCouponGoodsCountServiceResponseSchema),
  ),
);
